
import { Avatar } from "@mui/material";
import { createPopper } from "@popperjs/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AgentTemplateNotSelected,
  AgentTemplateSelected,
  LogNotSelected,
  LogSelected,
  MappingNotSelected,
  MappingSelected,
  TemplateNotSelected,
  TemplateSelected,
  UserNotSelected,
  UserSelected,
  JourneyNotSelected,
  JourneySelected,
  QnaSelected,
  QnaNotSelected,
  FunctionSelected,
  FuntionNotSelected,
  MonitoringSelected,
  MonitoringNotSelected,
  VerificationSettingsSelected,
  VerificationSettingsNotSelected,
} from "../../Icons/icons";
import AuthContext from "../../context/AuthContext";
import Cookies from "js-cookie";

const SideBar = () => {
  const location = useLocation();
  const { user } = useContext(AuthContext)
  let pathName = location.pathname;

  const [tooltipShow, setTooltipShow] = useState(null);
  const btnRefs = useRef([]);
  const tooltipRefs = useRef([]);

  const openTooltip = (index) => {
    createPopper(btnRefs.current[index], tooltipRefs.current[index], {
      placement: "right",
    });
    setTooltipShow(index);
  };

  const closeTooltip = () => {
    setTooltipShow(null);
  };

  const [filteredMenuItems, setFilteredMenuItems] = useState([])

  const menuItems = [
    {
      path: "/dashboard/journeys",
      selectedIcon: <JourneySelected />,
      unSelectedIcon: <JourneyNotSelected />,
      label: "Journeys",
      roles: ["ADMIN", "USER", "GCUSER", "ASSESSOR"]
    },
    {
      path: "/dashboard/templates",
      selectedIcon: <TemplateSelected />,
      unSelectedIcon: <TemplateNotSelected />,
      label: "Templates",
      roles: ["ADMIN"]
    },
    {
      path: "/dashboard/agent-template-associations",
      selectedIcon: <AgentTemplateSelected />,
      unSelectedIcon: <AgentTemplateNotSelected />,
      label: "Agent-Template Association",
      roles: ["ADMIN"]
    },
    {
      path: "/dashboard/verification-settings",
      selectedIcon: <VerificationSettingsSelected />,
      unSelectedIcon: <VerificationSettingsNotSelected />,
      label: "Face Verification Settings",
      roles: ["ADMIN"],
      // Stay highlighted on the create / edit sub-pages too.
      matchSubRoutes: true,
    },
    {
      path: "/dashboard/users",
      selectedIcon: <UserSelected />,
      unSelectedIcon: <UserNotSelected />,
      label: "Users",
      roles: ["ADMIN", "SUPPORT"]
    },
    {
      path: "/dashboard/logs",
      selectedIcon: <LogSelected />,
      unSelectedIcon: <LogNotSelected />,
      label: "Logs",
      roles: ["ADMIN", "USER", "GCUSER", "ASSESSOR"]
    },
    {
      path: "/dashboard/variable-mappings",
      selectedIcon: <MappingSelected />,
      unSelectedIcon: <MappingNotSelected />,
      label: "Variable Mappings",
      roles: ["ADMIN"]
    },
    {
      path: "/dashboard/question-answer",
      selectedIcon: <QnaSelected />,
      unSelectedIcon: <QnaNotSelected />,
      label: "Question-Answer",
      roles: ["ADMIN"]
    },
    {
      path: "/dashboard/functionality",
      selectedIcon: <FuntionNotSelected />,
      unSelectedIcon: <FunctionSelected />,
      label: "Utilities",
      roles: ["ADMIN"]
    },
    {
      path: "/dashboard/monitoring",
      selectedIcon: <MonitoringNotSelected />,
      unSelectedIcon: <MonitoringSelected />,
      label: "Monitoring",
      roles: ["ADMIN"]
    },
  ];

  useEffect(() => {
    const userRole = JSON.parse(Cookies.get("userDets") || "{}").role;
    const items = menuItems.filter((item) =>
      item.roles.includes(userRole)

    );
    setFilteredMenuItems(items)
  }, [])



  return (
    <nav className="bg-white px-4 py-3 flex flex-col justify-between items-center">
      <div>
        {filteredMenuItems.map((item, index) => (
          <div
            key={index}
            ref={(el) => (btnRefs.current[index] = el)}
            onMouseEnter={() => openTooltip(index)}
            onMouseLeave={closeTooltip}
            className="flex items-center justify-center mt-6 relative"
          >
            <Link to={item.path}>
              <div className="flex items-center justify-center">
                {React.cloneElement(
                  pathName === item.path ||
                    (item.matchSubRoutes &&
                      pathName.startsWith(`${item.path}/`))
                    ? item.selectedIcon
                    : item.unSelectedIcon,
                  {
                    className: `w-6 h-6 `,
                  }
                )}
              </div>
            </Link>
            <div
              ref={(el) => (tooltipRefs.current[index] = el)}
              className={`absolute z-10 transition-opacity duration-200 flex flex-row ${tooltipShow === index
                ? "opacity-100"
                : "opacity-0 pointer-events-none"
                }`}
            >
              <div className="w-2 overflow-hidden  ">
                <div className="h-3 mt-2.5 bg-gray-900 dark:bg-gray-900 -rotate-45 transform origin-top-right"></div>
              </div>
              <div className="rounded-md  p-2 bg-gray-900 dark:bg-gray-900">
                <p className="text-xs text-gray-200">{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <div className="mt-6">
        <Avatar className="w-10 h-10">
          <img src="https://picsum.photos/200/300" alt="Avatar" />
        </Avatar>
      </div> */}
    </nav>
  );
};

export default SideBar;
